import { Slider as MuiSlider, withStyles } from '@material-ui/core';

const Slider = withStyles({
  root: {
    color: '#90caf9',
    height: 4,
  },
  thumb: {
    height: 16,
    width: 16,
    backgroundColor: '#fff',
    border: '2px solid #90caf9',
    marginTop: -6,
    marginLeft: -8,
    '&:focus, &:hover, &$active': {
      boxShadow: '0px 0px 0px 8px rgba(144, 202, 249, 0.16)',
    },
  },
  active: {},
  track: {
    height: 4,
    borderRadius: 2,
  },
  rail: {
    height: 4,
    borderRadius: 2,
    backgroundColor: '#555',
  },
  mark: {
    backgroundColor: '#888',
    height: 8,
    width: 1,
    marginTop: -2,
  },
  markActive: {
    opacity: 1,
    backgroundColor: '#90caf9',
  },
  valueLabel: {
    color: '#222'
  },
})(MuiSlider);

export default Slider;
